import { ItemsPerPage } from '@billy/design-system'
import { useMemo } from 'react'

import { SortDirection } from '../../../enums/sortDirection'
import { useQueryParams } from '../../../hooks/useQueryParams'
import { AccountSortProperty } from '../types/accountSortProperty'

interface AccountFilters {
  page?: number
  pageSize?: ItemsPerPage
  searchQuery?: string
  sortDirection: SortDirection
  sortProperty: AccountSortProperty
  period?: string
  withVoided: boolean
}

type UseAccountFiltersResponse = [
  AccountFilters,
  (filters: Partial<AccountFilters> | ((prevParams: Partial<AccountFilters>) => Partial<AccountFilters>)) => void,
]

export const defaultQuery: AccountFilters = {
  page: 1,
  pageSize: 100, // for this particular table we want to hardcode it to 100, so it doesn't use the global itemsPerPage mechanism
  searchQuery: '',
  sortDirection: SortDirection.Desc,
  sortProperty: 'entryDate', // BE has it's own sorting but we can at least simulate something to keep it in the url
  period: undefined,
  withVoided: false,
}

export const useAccountFilters = (): UseAccountFiltersResponse => {
  const [queryParams, setQueryParams] = useQueryParams<AccountFilters>({ defaultQuery })

  return useMemo(
    () => [
      {
        ...queryParams,
        page: Number(queryParams.page),
        pageSize: Number(queryParams.pageSize) as ItemsPerPage,
        withVoided:
          typeof queryParams.withVoided === 'string'
            ? queryParams.withVoided === 'true'
            : Boolean(queryParams.withVoided),
      },
      setQueryParams,
    ],
    [queryParams, setQueryParams],
  )
}
